function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Dropdown, FormControl, InputGroup, Spinner } from 'react-bootstrap';
import { XLg } from 'react-bootstrap-icons';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { INPUT_MAX_LENGTH } from '../config';
import { PlaceProvider, searchAutocomplete, usePlaceContext } from '../state/place';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

function SearchPlaceField(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      disabled = _ref.disabled;
  useEffect(function () {
    if (value.length > 0) {
      var fullname = value[0].fullname;
      setQuery(fullname);
      searchAutocompleteDispatch(fullname);
    }
  }, [value]);

  var _usePlaceContext = usePlaceContext(),
      _usePlaceContext$stat = _usePlaceContext.state,
      loading = _usePlaceContext$stat.loading,
      data = _usePlaceContext$stat.data,
      error = _usePlaceContext$stat.error,
      dispatchPlace = _usePlaceContext.dispatch;

  var searchAutocompleteDispatch = function searchAutocompleteDispatch(query) {
    return dispatchPlace(searchAutocomplete(query));
  };

  var intl = useIntl();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      query = _useState4[0],
      setQuery = _useState4[1];

  var clearQuery = function clearQuery() {
    setQuery('');
    searchAutocompleteDispatch('');
  };

  var handleClear = function handleClear() {
    clearQuery();
    focusInput();
  };

  var handleToggle = function handleToggle(isOpen, e, _ref2) {
    var source = _ref2.source;
    setOpen(isOpen);

    if (open) {
      if (data !== null && data.results.length === 1) {
        handleSelect(data.results[0]);
      } else if (source !== 'select') {
        clearQuery();
        onChange([]);
      }
    } else if (value.length > 0) {
      setQuery(value[0].fullname);
    } else {
      clearQuery();
    }
  };

  var handleChange = function handleChange(e) {
    var newQuery = e.target.value;
    setQuery(newQuery);
    searchAutocompleteDispatch(newQuery);
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.charCode === 13) {
      // Enter key (normal *and* numpad)
      if (data !== null && data.results.length > 0) {
        handleSelect(data.results[0]);
        e.preventDefault();
      }
    }
  };

  var handleSelect = function handleSelect(place) {
    onChange([place]);
    setQuery(place.fullname);
    searchAutocompleteDispatch(place.fullname);
  };

  var hasData = data !== null && data.results.length > 0;
  var inputRef = useRef(null);

  var focusInput = function focusInput() {
    return inputRef.current.focus();
  };

  useEffect(function () {
    if (open) {
      focusInput();
    }
  }, [open]);
  return /*#__PURE__*/_jsxs(Dropdown, {
    onToggle: handleToggle,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    children: [" ", /*#__PURE__*/_jsx(Dropdown.Toggle, {
      variant: "light",
      disabled: disabled,
      id: "place-dropdown",
      className: "text-left btn-block text-nowrap overflow-hidden",
      children: value.length > 0 ? value[0].fullname : /*#__PURE__*/_jsx(FormattedMessage, {
        id: "form.place"
      })
    }), /*#__PURE__*/_jsxs(Dropdown.Menu, {
      show: open,
      style: {
        minWidth: '100%'
      },
      children: [/*#__PURE__*/_jsxs(InputGroup, {
        className: "mx-3 my-1 w-auto",
        children: [/*#__PURE__*/_jsx(FormControl, {
          ref: inputRef,
          "aria-describedby": "basic-addon1",
          placeholder: intl.formatMessage({
            id: 'form.enter_place'
          }),
          onChange: handleChange,
          value: query,
          onKeyPress: handleKeyPress,
          maxLength: INPUT_MAX_LENGTH
        }), /*#__PURE__*/_jsx(InputGroup.Append, {
          children: /*#__PURE__*/_jsx(Button, {
            variant: "outline-secondary",
            disabled: !query,
            onClick: handleClear,
            children: /*#__PURE__*/_jsx(XLg, {})
          })
        })]
      }), loading && !hasData ?
      /*#__PURE__*/
      // Loading
      _jsx("div", {
        className: "text-center mt-3 mb-1",
        children: /*#__PURE__*/_jsx(Spinner, {
          animation: "border",
          role: "status",
          children: /*#__PURE__*/_jsx("span", {
            className: "sr-only",
            children: "Loading..."
          })
        })
      }) : hasData ?
      /*#__PURE__*/
      // Results
      _jsx("div", {
        className: "mt-3",
        children: data.results.map(function (place) {
          return /*#__PURE__*/_jsx(Dropdown.Item, {
            disabled: loading,
            onClick: function onClick() {
              return handleSelect(place);
            },
            active: data.results.length === 1,
            children: place.fullname
          }, place.id);
        })
      }) : error === null ? query.trim().length === 0 ? // Nothing typed
      null :
      /*#__PURE__*/
      // No result
      _jsx("div", {
        className: "mt-2",
        children: /*#__PURE__*/_jsx(Dropdown.Header, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "form.no_place_found"
          })
        })
      }) :
      /*#__PURE__*/
      // Error
      _jsx("div", {
        className: "mt-2",
        children: /*#__PURE__*/_jsx(Dropdown.Header, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "form.place_error"
          })
        })
      })]
    })]
  });
}

SearchPlaceField.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};
export function SearchPlaceInput(_ref3) {
  var disabled = _ref3.disabled;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Field, {
      name: "place",
      render: function render(_ref4) {
        var _ref4$input = _ref4.input,
            value = _ref4$input.value,
            onChange = _ref4$input.onChange;
        return /*#__PURE__*/_jsx(PlaceProvider, {
          children: /*#__PURE__*/_jsx(SearchPlaceField, {
            value: value,
            onChange: onChange,
            disabled: disabled
          })
        });
      }
    })
  });
}
SearchPlaceInput.propTypes = {
  disabled: PropTypes.bool.isRequired
};